// frontend/src/components/FaviconPlaylist.jsx
import { useEffect, useRef } from "react";

const FaviconPlaylist = () => {
  const stateRef = useRef({
    canvas: null,
    ctx: null,
    video: null,
    rafId: null,
    intervalId: null,
    toggleInterval: null,
    mode: "static", // 'static' | 'video'
    frameIndex: 0,
    frames: ["/favicon.png", "/favicon_1.png", "/favicon_2.png"],
    startTime: Date.now()
  });

  useEffect(() => {
    const state = stateRef.current;

    // 1. Initialisation Canvas (pour l'effet WAwa)
    state.canvas = document.createElement("canvas");
    state.canvas.width = 32;
    state.canvas.height = 32;
    state.ctx = state.canvas.getContext("2d");

    // Helper: Récupérer ou créer le link favicon (Optimisé: ne supprime pas le DOM)
    const getLink = () => {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      return link;
    };

    // --- MOTEUR WAWA ---
    
    // Effet Overlay coloré pulsant
    const drawWAwaEffect = () => {
        const time = (Date.now() - state.startTime) * 0.005;
        const pulse = Math.sin(time) * 0.3 + 0.7;
    
        // Gradient coloré WAwa
        const gradient = state.ctx.createRadialGradient(16, 16, 0, 16, 16, 16);
        gradient.addColorStop(0, `rgba(0, 255, 255, ${pulse * 0.3})`);
        gradient.addColorStop(1, `rgba(255, 0, 255, ${pulse * 0.1})`);
    
        state.ctx.globalCompositeOperation = "overlay";
        state.ctx.fillStyle = gradient;
        state.ctx.fillRect(0, 0, 32, 32);
        state.ctx.globalCompositeOperation = "source-over"; // Reset
    };

    // Boucle d'animation Vidéo
    const renderVideoLoop = () => {
        if (state.mode !== "video" || !state.video || state.video.paused) return;

        // 1. Dessiner la vidéo
        state.ctx.drawImage(state.video, 0, 0, 32, 32);
        
        // 2. Ajouter l'effet WAwa
        drawWAwaEffect();

        // 3. Mettre à jour le favicon (Juste le href !)
        const link = getLink();
        link.href = state.canvas.toDataURL("image/png");

        state.rafId = requestAnimationFrame(renderVideoLoop);
    };

    // Boucle d'animation Statique
    const playStatic = () => {
        const link = getLink();
        link.href = state.frames[state.frameIndex];
        state.frameIndex = (state.frameIndex + 1) % state.frames.length;
    };

    // Initialisation Vidéo
    const initVideo = () => {
        const v = document.createElement("video");
        v.src = "/vid_favicon.mp4";
        v.loop = true;
        v.muted = true; // Obligatoire
        v.autoplay = true;
        v.crossOrigin = "anonymous";
        
        v.onloadeddata = () => {
            console.log("🎬 WAwa Vidéo chargée !");
            state.video = v;
        };
        
        v.onerror = () => {
            console.warn("⚠️ Fallback static (vidéo non trouvée)");
            state.mode = "static"; // Force le mode statique si erreur
        };
        
        // Tentative de lecture
        v.play().catch(e => console.log("Autoplay bloqué, attente interaction user"));
    };

    // --- LOGIQUE PRINCIPALE ---

    // 1. Démarrer en statique
    state.intervalId = setInterval(() => {
        if (state.mode === "static") playStatic();
    }, 600); // 600ms en statique

    // 2. Charger la vidéo
    initVideo();

    // 3. Alternance Auto (10s Vidéo / 10s Images)
    state.toggleInterval = setInterval(() => {
        // Si la vidéo n'est pas chargée, on reste en statique
        if (!state.video || state.video.readyState < 2) return;

        state.mode = state.mode === "video" ? "static" : "video";
        
        if (state.mode === "video") {
            state.video.play().catch(e => {});
            renderVideoLoop();
        } else {
            state.video.pause();
            cancelAnimationFrame(state.rafId);
        }
    }, 10000);

    // Nettoyage à la destruction du composant
    return () => {
        clearInterval(state.intervalId);
        clearInterval(state.toggleInterval);
        cancelAnimationFrame(state.rafId);
        if (state.video) state.video.pause();
        const link = getLink();
        link.href = "/favicon.png"; // Reset propre
    };
  }, []);

  return null; // Composant invisible
};

export default FaviconPlaylist;